import axios from 'axios';
import config from '../Config';
import authHeader from './auth-header';

const API_URL = config.API_URL;
const API_VERSION = config.API_VERSION;
const getDieSubCategoryList = (page, pagesize, search, ordering) => {
  return axios.get(`${API_URL}/api/${API_VERSION}/die-subcategory/`, {
    headers: authHeader(),
    params: {
      deleted: 0,
      page: page,
      pagesize: pagesize,
      search: search,
      ordering: ordering
    },
  });
};
const getDieSubCategoryListDropdown = (page, pagesize, search, ordering) => {
  return axios.get(`${API_URL}/api/${API_VERSION}/die-subcategory/`, {
    headers: authHeader(),
    params: {
      fields: 'id,name,deleted',
      page: page,
      pagesize: pagesize,
      search: search,
      ordering: ordering
    },
  });
};
const getDieArchiveSubCategoryList = (page, pagesize, search, ordering) => {
  return axios.get(API_URL + '/api/' + API_VERSION + '/die-subcategory/archived/', {
    headers: authHeader(), params: {
      page: page,
      pagesize: pagesize,
      search: search,
      ordering: ordering,
    }
  });
};
const addDieSubCategory = (newSubCategory) => {
  return axios.post(
    `${API_URL}/api/${API_VERSION}/die-subcategory/`,
    newSubCategory,
    { headers: authHeader() }
  );
};
const editDieSubCategory = (id, updatedData) => {
  return axios.patch(
    `${API_URL}/api/${API_VERSION}/die-subcategory/${id}/`,
    updatedData,
    { headers: authHeader() }
  );
};

const deleteDieSubCategory = (id) => {
  return axios.post(
    `${API_URL}/api/${API_VERSION}/die-subcategory/${id}/archive/`, // Include the die group's ID in the URL
    {},
    { headers: authHeader() } // Authentication header
  );
};
const unArchiveDieSubCategory = (id) => {
  return axios.post(
    `${API_URL}/api/${API_VERSION}/die-subcategory/${id}/restore/`, // Include the die group's ID in the URL
    {}, // Pass an empty object if no data needs to be sent
    { headers: authHeader() } // Authentication header
  );
};

const bulkArchiveDieSubCategory = ids => {
  return axios.post(
    `${API_URL}/api/${API_VERSION}/die-subcategory/bulk-archive/`,
    { ids: Array.isArray(ids) ? ids : [ids] },
    { headers: authHeader() },
  );
};
const restoreDieSubCategory = ids => {
  return axios.post(
    `${API_URL}/api/${API_VERSION}/die-subcategory/bulk-restore/`,
    { ids: Array.isArray(ids) ? ids : [ids] },
    { headers: authHeader() },
  );
};
const dieSubCategoryListService = {
  getDieSubCategoryList,
  getDieArchiveSubCategoryList,
  addDieSubCategory,
  editDieSubCategory,
  deleteDieSubCategory,
  unArchiveDieSubCategory,
  getDieSubCategoryListDropdown,
  bulkArchiveDieSubCategory,  
  restoreDieSubCategory,
};

export default dieSubCategoryListService;
